var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerGeoGrubengasPressureReliefUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450-647.69v-120H290v-60h380v60H510v120h-60ZM170-132.31v-300h60v40h140v-140h-40v-60h300v60h-40v140h140v-40h60v300h-60v-40H230v40h-60Zm60-100h500v-100H530v-200H430v200H230v100Zm250 0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerGeoGrubengasPressureReliefUnitIcon);
export default __webpack_public_path__ + "static/media/marker-geoGrubengasPressureReliefUnit-icon.bf46f2b703e68d4b20f087af5b078557.svg";
export { ForwardRef as ReactComponent };